import {
  ListMessageSetSubmissionsV2,
  ListMessageSetSubmissionsV2Variables
} from './__generated__/ListMessageSetSubmissionsV2'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMessageSetSubmissionsV2($input: ListSubmittedMessageSetInputV2!) {
    listSubmittedMessageSets: listSubmittedMessageSetsV2(input: $input) {
      submittedMessageSets {
        id
        createdAt
        personId
        personConnection {
          person {
            firstName
            lastName
          }
        }
        title
        messageIds
        description
        isNote
        originalBoardId
      }
      nextCursor
    }
  }
`

export const useListMessageSetSubmissions = (variables: ListMessageSetSubmissionsV2Variables) => {
  return useQuery<ListMessageSetSubmissionsV2, ListMessageSetSubmissionsV2Variables>(QUERY, {
    variables
  })
}
